// Studyo Today Backend
// Package studyo.today.schools.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/schools/v1/resources/workload_summary.proto (package studyo.today.schools.v1.resources, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_studyo_today_schools_v1_resources_workload_status } from "./workload_status_pb.js";

/**
 * Describes the file studyo/today/schools/v1/resources/workload_summary.proto.
 */
export const file_studyo_today_schools_v1_resources_workload_summary = /*@__PURE__*/
  fileDesc("CjhzdHVkeW8vdG9kYXkvc2Nob29scy92MS9yZXNvdXJjZXMvd29ya2xvYWRfc3VtbWFyeS5wcm90bxIhc3R1ZHlvLnRvZGF5LnNjaG9vbHMudjEucmVzb3VyY2VzIusBCg9Xb3JrbG9hZFN1bW1hcnkSSQoOaGlnaGVzdF9zdGF0dXMYASABKA4yMS5zdHVkeW8udG9kYXkuc2Nob29scy52MS5yZXNvdXJjZXMuV29ya2xvYWRTdGF0dXMSJAocaGlnaGVzdF9zdGF0dXNfc3R1ZGVudF9jb3VudBgCIAEoBRIbChN0b3RhbF9zdHVkZW50X2NvdW50GAMgASgFEiYKHmltcG9ydGFudF9wdWJsaXNoZWRfd29ya19jb3VudBgEIAEoBRIiChp0b3RhbF9wdWJsaXNoZWRfd29ya19jb3VudBgFIAEoBUIpqgImU3R1ZHlvLlRvZGF5LlNjaG9vbHMuR3JwYy5WMS5SZXNvdXJjZXNiBnByb3RvMw", [file_studyo_today_schools_v1_resources_workload_status]);

/**
 * Describes the message studyo.today.schools.v1.resources.WorkloadSummary.
 * Use `create(WorkloadSummarySchema)` to create a new message.
 */
export const WorkloadSummarySchema = /*@__PURE__*/
  messageDesc(file_studyo_today_schools_v1_resources_workload_summary, 0);

